<template>
  <div id="about">
      <b-row align-h="center">
          <b-col col lg="5" md="5" cols="10">
            <div id="sobre_img" class="about-img">
              <img src="../img/us.jpg" class="img-fluid" alt>
            </div>
          </b-col>
        <b-col col lg="5" md="5" cols="10">
            <div class="about-content">
                <h2 id="sobre_titulo" class="tnt">Sobre nós</h2>
              <ul>
                <li id="sobre_msg1">
                  <i class="icon ion-md-bookmark"></i> 
                  <span> Maria Bailarina existe desde 2013 em Campo Mourão ofertando aulas de balé clássico em parceria com algumas escolas da cidade, com o intuito de que esta arte seja cada vez mais disseminada e que a partir dela a criança possa se desenvolver e aprender novas formas de existir e perceber o mundo. Prezando sempre pela aprendizagem prazerosa e divertida desta dança. </span>
                </li>
                <li id="sobre_msg2">
                  <i class="icon ion-md-bookmark"></i> 
                  <!-- <span> Hoje somos em três professoras, que juntas temos (a princípio) nove escolas parceiras, 170 bailarinas que constroem diariamente a nossa história, e muitos familiares que confiam em nosso trabalho e sonham nossos sonhos. </span> -->
                  <span>Atualmente somos em cinco professoras, que juntas atendemos cinco escolas parceiras, centenas de bailarinas que constroem diariamente a nossa história, e muitos familiares que confiam em nosso trabalho e sonham nossos sonhos.</span>
                </li>
              </ul>
            </div>
        </b-col>
      </b-row>
  </div>
</template>


<script>

export default {
  name: "sobre",
  data() {
    return {
      mostrar: false
    };
  },
  methods: {
    animationElement(posEl, isMostrar) {
      let elimg = document.querySelector('#sobre_img')
      let eltitulo = document.querySelector('#sobre_titulo')
      let elmsg1 = document.querySelector('#sobre_msg1')
      let elmsg2 = document.querySelector('#sobre_msg2')
      if (isMostrar) {
        elimg.classList.add('animate__animated', 'animate__backInLeft')
        eltitulo.classList.add('animate__animated', 'animate__bounceInRight')
        eltitulo.style.setProperty('--animate-duration', '0.7s')
        elmsg1.classList.add('animate__animated', 'animate__bounceInRight')
        elmsg1.style.setProperty('--animate-duration', '1.0s')
        elmsg2.classList.add('animate__animated', 'animate__bounceInRight')
        elmsg2.style.setProperty('--animate-duration', '1.5s')
      } else {
        elimg.classList.remove('animate__animated', 'animate__backInLeft')
        eltitulo.classList.remove('animate__animated', 'animate__bounceInRight')
        elmsg1.classList.remove('animate__animated', 'animate__bounceInRight')
        elmsg2.classList.remove('animate__animated', 'animate__bounceInRight')
      }
    }
  }
};
</script>

<style scoped>

#about {
  padding: 100px 0 100px 0;
}


#about .about-content {
  padding-top: 40px;
}

#about .about-content h2 {
  color: #413e66;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

#about .about-content h3 {
  color: #696592;
  font-weight: 400;
  font-size: 22px;
  font-style: italic;
}

#about .about-content p {
  font-size: 20px;
  padding: 35px 0px 35px 0px;
}

#about .about-content ul {
  list-style: none;
  padding: 0;
}

#about .about-content ul li {
  padding: 15px 0px 15px 0px;
  font-size: 20px;
}

#about .about-content ul li i {
  font-size:30px;
  padding-right: 4px;
  color: #1bb1dc;
}

#about .about-img {
  position: relative;
  margin: 30px 30px 30px 30px;
  opacity: 1;
}

#about .about-img img {
  width: 100%;
  border: 8px solid #fff;
  transition: 0.8s;
}

#about .about-img img:hover {
  width: 100%;
  opacity: 1 !important;
  filter: alpha(opacity=100);
  -webkit-transform: scale(1.03);
  transform: scale(1.03);
}

#about .about-img::before {
  position: absolute;
  left: -31px;
  top: -30px;
  width: 90%;
  height: 92%;
  z-index: -1;
  content: "";
  background-color: #ebf1fa;
  transition: 0.5s;
}

#about .about-img::after {
  position: absolute;
  right: -31px;
  bottom: -30px;
  width: 90%;
  height: 92%;
  z-index: -1;
  content: "";
  background-color: #ebf1fa;
  transition: 0.5s;
}


@media screen and (max-width: 767px) {  
  #about .about-img {
    margin: 0px;
  }


  #about .about-content ul li {
    padding: 5px 0px 5px 0px;
    font-size: 16px;
  }


  #about .about-content p {
    font-size: 16px;
    padding: 5px 0px 5px 0px;
  }

}



</style>



// WEBPACK FOOTER //
// src/views/sobre.vue